export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">联系我们</h2>
          <p className="mt-2 text-sm text-foreground-500">有合作需求或意见建议？欢迎随时联系我们</p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="text-center">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-xl text-primary-500"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">bd@yymanhua.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-chat-3-line text-xl text-accent-500"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-500">submit@yymanhua.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-question-answer-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">问题反馈</h3>
              <p className="text-xs text-foreground-500">support@yymanhua.com</p>
            </div>
          </div>

          <div className="border-t border-background-200/60 pt-6 text-center">
            <p className="text-xs text-foreground-400">
              也可以通过站内反馈功能提交意见，我们会在 24 小时内回复
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}